import React from "react";
import { Modal, Button } from "react-bootstrap";

const PDFViewerModal = ({ show, onHide, fileUrl }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>PDF Viewer</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh", // Ensure full height for centering
          textAlign: "center",
        }}
      >
        {fileUrl ? (
          <iframe
            src={fileUrl}
            title="PDF Viewer"
            width="90%"
            height="100%"
            style={{ border: "none" }}
          ></iframe>
        ) : (
          <p>No PDF file selected.</p>
        )}
      </Modal.Body>
      <Modal.Footer style={{ justifyContent: "center" }}>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PDFViewerModal;
